export default __webpack_public_path__ + "static/media/why_send_with_us.06a88032.png";